import { useSelector } from 'react-redux';

import { INSURANCE_TYPES } from '../../../../../../../constants';
import { INSURANCE_DOCUMENT_SUB_TYPES } from '../../insurance/constants';
import { findInsuranceByType, getInsuranceCardDocument } from '../../insurance/hooks/utils';

import type { RootState } from '../../../../../../../store';

export default function useSecondaryInsuranceState() {
  const noSecondaryInsurance = useSelector(
    (state: RootState) =>
      state.onboardingQuestionnaire.onboardingQuestionnaireDetails?.no_secondary_insurance ?? false,
  );
  const hasSavedSecondaryInsurance = useSelector((state: RootState) => {
    const details = state.onboardingQuestionnaire.onboardingQuestionnaireDetails;
    const hasSecondaryInsuranceRow = Boolean(
      findInsuranceByType(details?.insurances, INSURANCE_TYPES.SECONDARY),
    );
    const hasSecondaryCardDocument = Boolean(
      getInsuranceCardDocument(details?.documents, INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_FRONT) ||
        getInsuranceCardDocument(details?.documents, INSURANCE_DOCUMENT_SUB_TYPES.SECONDARY_BACK),
    );
    return hasSecondaryInsuranceRow || hasSecondaryCardDocument;
  });

  return { noSecondaryInsurance, hasSavedSecondaryInsurance };
}
